import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import TitleTooltip from '../TitleTooltip';
export default function Label(_ref) {
  var children = _ref.children,
      title = _ref.title,
      theme = _ref.theme,
      placement = _ref.placement,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(TitleTooltip, {
    theme: theme,
    placement: placement,
    visibility: function visibility(ref) {
      return title || ref.scrollHeight > ref.clientHeight;
    },
    title: title || children
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(className, 'jmtd-label')
  }, children));
}
Label.propTypes = {
  children: PropTypes.node,
  title: PropTypes.node,
  theme: PropTypes.oneOf(['light', 'dark']),
  placement: PropTypes.string,
  className: PropTypes.string
};
Label.defaultProps = {
  children: null,
  title: null,
  theme: 'dark',
  placement: 'bottomLeft',
  className: ''
};